import { useEffect, useState } from 'react';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const update = () => setOffline(!navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  if (!offline) return null;
  return (
    <div className="fixed inset-x-0 top-0 z-[3000] flex justify-center px-3 pt-[calc(env(safe-area-inset-top)+0.5rem)] pointer-events-none">
      <div className="rounded-full border border-amber-400/40 bg-amber-400/95 px-3 py-1.5 text-xs font-semibold text-black shadow-lg">
        Offline mode · showing cached data
      </div>
    </div>
  );
}
